import classNames from 'classnames';
import Typography from '../typography/typography';
import styles from './spinner.module.scss';

export interface SpinnerProps {
  /** The class name to apply */
  className?: string;
  /** Whether the overlay has a background color applied */
  hasTransparentOverlay?: boolean;
  /** The size of the spinner */
  isSmall?: boolean;
  /** The loading text to show under the spinner */
  loadingText?: string | undefined;
}

const Spinner = ({
  className,
  hasTransparentOverlay = false,
  isSmall = false,
  loadingText,
}: SpinnerProps) => {
  return (
    <div
      className={classNames(styles.component, className, {
        [styles.hasTransparentOverlay]: hasTransparentOverlay,
        [styles.isSmall]: isSmall,
      })}
    >
      <div className={styles.spinnerOverlay}>
        <div className={styles.spinner} />

        {loadingText && (
          <Typography className={styles.loadingText}>{loadingText}</Typography>
        )}
      </div>
    </div>
  );
};

Spinner.displayName = 'Spinner';

export default Spinner;
